import { render, staticRenderFns } from "./index.vue?vue&type=template&id=75cb689c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=75cb689c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cb689c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SpecialMultiCategory: require('/home/korzinka/www/front/components/SpecialMultiCategory.vue').default,SpecialSingleCategory: require('/home/korzinka/www/front/components/SpecialSingleCategory.vue').default})
